export const getInvitationEmailMarkup = (title, description) => `
    <p>
        You have been invited to participate in a new project, <strong style="font-weight: 800; color: black">${title}</strong>!
    </p>
    <h4>&nbsp;</h4>
    <h4>Project details: </h4>
    <div style="whiteSpace: pre-wrap">${description}</div>
`
